<template>
  <div class="PostsListItem media media-post">
    <div class="media-body">
      <div class="media-post-text">
        <h5 class="h4 mt-0">
          {{post.userEmail}}
        </h5>
        <div class="PostsListItem__date">
          {{post.date | moment("MMM Do, h:mm")}}
        </div>
        <p class="lh-160" v-html="postText"></p>
      </div>
      <div class="PostsListItem__comments">
        <row-comments :rowKey="post.id" />
      </div>
    </div>
  </div>
</template>
<script>
import RowComments from '@/components/DataGrid/FormBuilder/gui/ui/comments/RowComments';

export default {
  name: 'PostsListItem',
  components: {
    RowComments
  },
  props: {
    post: {
      type: Object,
      required: true
    },
  },
  computed: {
    postText() {
      return (this.post.text || '').replace(/[\r\n]/g, '<br>');
    }
  }
}
</script>
<style lang="scss">
.PostsListItem {
  flex-direction: column;
  align-items: stretch;
  margin-top: 15px;

  &__CommentsList {
    margin-left: 50px;
  }

  &__CommentForm { 
    margin-top: 10px;
  }

  &__date {
    font-size: 11px;
    margin-bottom: 5px;
    color: grey;
  }
}
</style>
